/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentInfo } from "./PaymentInfo";
import { TransactionStatus } from "./TransactionStatus";
import { AmountEuroCents } from "./AmountEuroCents";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";
import { PatternString } from "@pagopa/ts-commons/lib/strings";

export enum ClientIdEnum {
  "IO" = "IO",

  "CHECKOUT" = "CHECKOUT",

  "CHECKOUT_CART" = "CHECKOUT_CART",

  "UNKNOWN" = "UNKNOWN"
}

export enum SendPaymentResultOutcomeEnum {
  "OK" = "OK",

  "KO" = "KO",

  "NOT_RECEIVED" = "NOT_RECEIVED"
}

/**
 * Transaction data returned when creating a new transaction
 */

// required attributes
const NewTransactionResponseR = t.interface({
  transactionId: t.string,

  payments: t.readonlyArray(PaymentInfo, "array of PaymentInfo"),

  status: TransactionStatus
});

// optional attributes
const NewTransactionResponseO = t.partial({
  feeTotal: AmountEuroCents,

  clientId: enumType<ClientIdEnum>(ClientIdEnum, "clientId"),

  authToken: t.string,

  idCart: t.string,

  sendPaymentResultOutcome: enumType<SendPaymentResultOutcomeEnum>(
    SendPaymentResultOutcomeEnum,
    "sendPaymentResultOutcome"
  ),

  authorizationCode: t.string,

  errorCode: t.string,

  gateway: PatternString("XPAY|VPOS|NPG")
});

export const NewTransactionResponse = t.intersection(
  [NewTransactionResponseR, NewTransactionResponseO],
  "NewTransactionResponse"
);

export type NewTransactionResponse = t.TypeOf<typeof NewTransactionResponse>;
